import { z } from 'zod';
export const ScoreSchema = z
    .number()
    .min(1)
    .max(5)
    .describe('Score from 1-5 where 1=very poor, 2=poor, 3=fair, 4=good, 5=excellent');
export const RecommendationsSchema = z
    .array(z.string())
    .min(2)
    .max(5)
    .describe('List of 2-5 specific, actionable recommendations for improvement');
export const BaseScorerSchema = z.object({
    score: ScoreSchema,
    recommendations: RecommendationsSchema,
});
// Zod schemas for validation (backend only)
export const MetadataCompletenessSchema = BaseScorerSchema;
export const ExploreAnalysisSchema = BaseScorerSchema;
export const InstructionQualitySchema = BaseScorerSchema;
//# sourceMappingURL=agentReadiness.js.map